import React from 'react';
import { Layout } from '@components/team';
import { EditOthers as OthersEdit } from '@components/team';

const EditOthers = () => {
    return <OthersEdit />;
};
EditOthers.Layout = Layout;
export default EditOthers;
